// extracted by mini-css-extract-plugin
module.exports = {"cWhite":"#FFFFFF","hOkShareBtn":"32px","OKShareBtn":"OKShareBtn_OKShareBtn__3Uvz9","OK":"OKShareBtn_OK__uqgxU","OKShareBtnTitle":"OKShareBtn_OKShareBtnTitle__17jfU"};